import Image from 'next/image';
import {useEffect, useRef, useState} from 'react';

export interface Option {
  label: string;
  icon?: string;
  id: string | number;
}

interface SelectOptionsInterface {
  options: Array<Option>;
  OptionElement?: ({value}: {value: Option}) => JSX.Element;
  selected?: Option;
  placeholder: string;
  OnOptionSelected?: ({value}: {value: Option}) => void;
}

const SelectOptions = ({
  options,
  OptionElement,
  selected,
  placeholder,
  OnOptionSelected,
}: SelectOptionsInterface) => {
  const selectedBox = useRef<any>();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    const OuterClick = (e: MouseEvent) => {
      if (selectedBox.current && !selectedBox.current.contains(e.target)) {
        setIsOpen(false);
      }
    };

    window.addEventListener('click', OuterClick);

    () => window.removeEventListener('click', OuterClick);
  }, []);

  const handleSelectClick = () => {
    setIsOpen(!isOpen);
  };

  const handleOptionClick = ({
    value,
    e,
  }: {
    value: Option;
    e: React.MouseEvent<HTMLLIElement, MouseEvent>;
  }) => {
    e.stopPropagation();
    e.preventDefault();
    OnOptionSelected && OnOptionSelected({value});
    setIsOpen(false);
  };

  const listOption = options.filter((value) => {
    if (value.id !== selected?.id) {
      return value;
    }
  });

  return (
    <div>
      <div
        className="py-3 px-4 w-full rounded-md text-dark-grey border border-light-grey hover:border-grey"
        ref={selectedBox}
        onClick={handleSelectClick}
      >
        <div className="flex gap-1">
          {selected && selected.icon ? <img src={selected.icon} alt="selected" /> : null}
          <span className="text-dark-grey">{selected ? selected.label : placeholder}</span>
        </div>
      </div>
      <div>
        {isOpen && listOption.length > 0 ? (
          <div className="z-50 relative">
            <ul className="bg-white dark:bg-dark-navy dark:text-white absolute overlay w-full max-h-80 p-3 rounded-md overflow-y-auto">
              {listOption.map((value) => {
                return (
                  OptionElement && (
                    <li
                      key={value.id}
                      className="px-3 py-3 cursor-pointer"
                      onClick={(e) => handleOptionClick({value, e})}
                    >
                      {OptionElement({value})}
                    </li>
                  )
                );
              })}
            </ul>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default SelectOptions;
